import React from 'react';
import View from 'components/tmisc/portal/developing/Developing.view';

const PortalDeveloping = ({ flow }) => {
	return (
		<View
			flow={flow}
		/>
	);
}

export default PortalDeveloping;
